import React, { useCallback, useEffect, useState } from "react";

import { Form, Field } from "formik";

import { registerLocale, setDefaultLocale } from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";
import { IoHelpCircle } from "react-icons/io5";

import {
  Flex,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  HStack,
  Text,
  Tooltip,
  Icon,
  useBreakpointValue,
} from "@chakra-ui/react";

import { Group } from "../../Group";
import { CustomDatepickerWField } from "../../../../components/CustomDatepickerWField";
import { CustomSelectWField } from "../../../../components/CustomSelectWField";
import { useFormikContext } from "formik";

import CustomSelect from "../../../../components/CustomSelect";
import MaskedInput from "react-text-mask";
import CustomDropzone from "../../../../components/CustomDropzone";

import FamiliaAcolhedoraSAService from "../../../../../main/services/FamiliaAcolhedoraSAService";
import ServicoAcolhimentoService from "../../../../../main/services/ServicoAcolhimentoService";
import DadosGeograficosService from "../../../../../main/services/DadosGeograficosService";
import CargaSelecaoService from "../../../../../main/services/CargaSelecaoService";
import { PopoverGenero } from "../../../../components/PopoverGenero";
import { isValidCPF } from "../../../../utils/isValidCPF";
import Swal from "sweetalert2";
import FileInformation from "../../../../components/FileInformation";

export const FamiliaAcolhedora = ({
  props,
  idServicoAcolhimento,
  id,
  setMesmaFamilia,
  invalidCPF,
  criancaCPFValid,
  messageValid,
  setMessageValid,
  disabledMPTJ,
  anexoGuiaEditadoTermoGuarda,
  setAnexoGuiaEditadoTermoGuarda,
  movimentacaoEditar,
  dataNascimentoFuturaFamilia,
  movimentacaoData,
}) => {
  const { setFieldValue } = useFormikContext();
  const [generos, setGeneros] = useState({ options: [], isLoading: false });
  const [bairros, setBairros] = useState({ options: [], isLoading: false });
  const [, setFamiliaAcolhedora] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [isFocused, setIsFocused] = useState(false);
  const [isBlur, setIsBlur] = useState(false);

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [props.values?.idGeneroFamiliaAcolhedora]);

  useEffect(() => {
    ServicoAcolhimentoService.getServicoAcolhimento(
      props.values.idServicoAcolhimento.id || idServicoAcolhimento
    )
      .then((res) => {
        setBairros((prevState) => ({ ...prevState, isLoading: true }));

        DadosGeograficosService.pesquisarBairros(res.data.endereco.municipio.id)
          .then((resp) => {
            setBairros({ options: resp.data, isLoading: false });
          })
          .catch((error) => {
            console.log("Erro ao pesquisar o bairro", error);
          });
      })
      .catch((error) => {
        console.log("Erro ao acessar o Servico de Acolhimento", error);
      });
  }, [props.values.idServicoAcolhimento.id, idServicoAcolhimento]);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const getGeneroLabel = (idGenero) => {
    return idGenero === 1
      ? { id: 1, label: "MASCULINO" }
      : idGenero === 2
      ? { id: 2, label: "FEMININO" }
      : idGenero === 3
      ? { id: 2, label: "HOMEM TRANS" }
      : idGenero === 4
      ? { id: 2, label: "MULHER TRANS" }
      : idGenero === 5
      ? { id: 2, label: "NÃO BINÁRIO" }
      : idGenero === 6
      ? { id: 2, label: "TRAVESTI" }
      : idGenero === 7
      ? { id: 2, label: "INTERSEXO" }
      : "";
  };

  const buscarFamiliaAcolhedora = useCallback(
    async (idServicoAcolhimento, cpf) => {
      const cpfFormated = cpf.replace(/[.-]|[.-](?=.)/g, "").trim();

      try {
        let res;

        if (id) {
          res = await FamiliaAcolhedoraSAService.getFamiliaAcolhedoraCPFCrianca(
            idServicoAcolhimento,
            cpfFormated,
            id
          );
        } else {
          res = await FamiliaAcolhedoraSAService.getFamiliaAcolhedoraCPF(
            idServicoAcolhimento,
            cpfFormated
          );
        }

        if (res.data) {
          Swal.fire({
            title: "Atenção!",
            text: `O CPF ${cpfFormated} pertence a ${res.data.nome}. Deseja utilizar os mesmos dados?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#169499",
            cancelButtonColor: "#169499",
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
          }).then((result) => {
            if (result.isConfirmed) {
              setFamiliaAcolhedora(res.data);
              setFieldValue("cpfFamiliaAcolhedora", cpfFormated || "");

              if (!res?.data?.idBairro) {
                setFieldValue("idBairroFamiliaAcolhedora", "");
              }

              setFieldValue("nomeFamiliaAcolhedora", res.data.nome || "");
              setFieldValue(
                "dataNascimentoFamiliaAcolhedora",
                res.data.dataNascimento
                  ? format(res.data.dataNascimento, "dd/MM/yyyy")
                  : ""
              );

              setFieldValue(
                "idGeneroFamiliaAcolhedora",
                getGeneroLabel(res.data.idGenero || "")
              );
            } else {
              setFieldValue("cpfFamiliaAcolhedora", "");
              setFieldValue("nomeFamiliaAcolhedora", "");
              setFieldValue("dataNascimentoFamiliaAcolhedora", "");
              setFieldValue("dataValidadeTermoGuarda", "");
              setFieldValue("idGeneroFamiliaAcolhedora", "");
            }
          });
        }
      } catch (error) {
        if (
          error?.response?.data?.field === "cpf" &&
          cpfFormated !== movimentacaoData?.familiaAcolhedora?.cpf
        ) {
          setMessageValid(error.response.data.message);
        }
        setFieldValue("cpfFamiliaAcolhedora", cpf || "");
        setFieldValue("nomeFamiliaAcolhedora", "");
        setFieldValue("dataNascimentoFamiliaAcolhedora", "");
        setFieldValue("dataValidadeTermoGuarda", "");
        setFieldValue("idGeneroFamiliaAcolhedora", "");
        if (
          setMesmaFamilia &&
          cpfFormated !== movimentacaoData?.familiaAcolhedora?.cpf
        ) {
          setMesmaFamilia(false);
        }

        console.log(error);
      }
    },
    [
      setFamiliaAcolhedora,
      setFieldValue,
      setMesmaFamilia,
      id,
      setMessageValid,
      movimentacaoData?.familiaAcolhedora?.cpf,
    ]
  );

  const buscarAcolhimento = useCallback(
    async (idServicoAcolhimento, cpf) => {
      const cpfFormated = cpf?.replace(/[.-]|[.-](?=.)/g, "").trim();

      try {
        const res = await FamiliaAcolhedoraSAService.getFamiliasAcolhedorasSA(
          idServicoAcolhimento
        );
        const criancas = res.data
          .filter((item) => item.cpf === cpfFormated)
          .map((item) => item.criancas);
        const mesmaFamilia = criancas[0]?.filter(
          (crianca) => crianca.id === Number(id)
        );

        if (
          setMesmaFamilia &&
          cpfFormated !== movimentacaoData?.familiaAcolhedora?.cpf
        )
          setMesmaFamilia(mesmaFamilia?.length > 0 ? true : false);
      } catch (error) {
        console.log(error);
      }
    },
    [id, setMesmaFamilia, movimentacaoData?.familiaAcolhedora?.cpf]
  );

  const handleCpfFamiliaAcolhedoraChange = useCallback(
    (idServicoAcolhimento, cpf) => {
      if (cpf.length === 14) {
        buscarFamiliaAcolhedora(idServicoAcolhimento, cpf);

        if (id) {
          buscarAcolhimento(idServicoAcolhimento, cpf);
        }
      }
    },
    [buscarAcolhimento, buscarFamiliaAcolhedora, id]
  );

  useEffect(() => {
    if (isValidCPF(props.values.cpfFamiliaAcolhedora)) {
      handleCpfFamiliaAcolhedoraChange(
        props.values.idServicoAcolhimento.id || idServicoAcolhimento,
        props.values.cpfFamiliaAcolhedora
          ? props.values.cpfFamiliaAcolhedora
          : ""
      );
    }
  }, [
    props.values.cpfFamiliaAcolhedora,
    idServicoAcolhimento,
    props.values.idServicoAcolhimento.id,
    handleCpfFamiliaAcolhedoraChange,
  ]);

  const handleGetGeneros = () => {
    setGeneros({ ...generos, isLoading: true });

    CargaSelecaoService.getGeneros().then((res) => {
      const tempOptions = res.data.map((genero) => {
        return {
          id: genero.id,
          label: (
            <HStack justifyContent="space-between">
              <Text
                color="#1A203D"
                fontWeight={400}
                fontSize={{ base: "12px", md: "14px" }}
              >
                {genero.genero}
              </Text>

              <Tooltip
                label={genero.descricao}
                fontSize="md"
                textAlign={"justify"}
                width="90%"
              >
                <span className="hint-tooltip">
                  <Icon
                    aria-label="Aviso de pendente"
                    color="#6B6C71"
                    as={IoHelpCircle}
                    boxSize={{ base: "10px", md: "20px" }}
                  />
                </span>
              </Tooltip>
            </HStack>
          ),
        };
      });
      setGeneros({ options: tempOptions, isLoading: false });
    });
  };

  return (
    <Group
      title={`${movimentacaoEditar ? "EDITAR" : "CADASTRAR"} ACOLHEDOR (A)`}
    >
      <Form>
        <Grid
          mt="15px"
          templateColumns={{ base: "repeat(1, 1fr)", lg: "repeat(6, 1fr)" }}
          gap="25px"
          rowGap="20px"
        >
          <GridItem colSpan={{ base: 1, sm: 3, lg: 2 }}>
            <Field name="cpfFamiliaAcolhedora">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.cpfFamiliaAcolhedora &&
                    form.touched.cpfFamiliaAcolhedora
                  }
                  id="cpfFamiliaAcolhedora"
                >
                  <FormLabel
                    color="#5F6377"
                    fontWeight="500"
                    fontSize="14px"
                    lineHeight="19.6px"
                    htmlFor="cpfFamiliaAcolhedora"
                  >
                    CPF*
                  </FormLabel>
                  <Input
                    {...field}
                    h="42px"
                    name="cpfFamiliaAcolhedora"
                    id="cpfFamiliaAcolhedora"
                    backgroundColor="#fff"
                    autoComplete="off"
                    border="1px solid #D7D8DE"
                    _placeholder={{
                      base: { fontSize: "14px" },
                      md: { fontSize: "16px" },
                    }}
                    placeholder="Informe o CPF"
                    guide={false}
                    mask={[
                      /\d/,
                      /\d/,
                      /\d/,
                      ".",
                      /\d/,
                      /\d/,
                      /\d/,
                      ".",
                      /\d/,
                      /\d/,
                      /\d/,
                      "-",
                      /\d/,
                      /\d/,
                    ]}
                    as={MaskedInput}
                    isDisabled={disabledMPTJ}
                    onFocus={() => setIsFocused(false)}
                    onBlur={() =>
                      props?.values?.cpfFamiliaAcolhedora?.replace(
                        /[^\d]+/g,
                        ""
                      ).length === 11 && setIsBlur(false)
                    }
                  />
                  <FormErrorMessage>
                    {form.errors.cpfFamiliaAcolhedora}
                  </FormErrorMessage>
                  {props.values.cpfFamiliaAcolhedora &&
                    !isFocused &&
                    !invalidCPF &&
                    !isBlur && (
                      <Text color="red" opacity={0.8} mt={2} fontSize="12px">
                        Informar um CPF válido
                      </Text>
                    )}
                  {props.values.cpfFamiliaAcolhedora &&
                    !isFocused &&
                    criancaCPFValid &&
                    invalidCPF &&
                    !messageValid &&
                    !isBlur && (
                      <Text color="red" opacity={0.8} mt={2} fontSize="12px">
                        CPF já cadastrado nessa ficha.
                      </Text>
                    )}
                  {props.values.cpfFamiliaAcolhedora &&
                    !isFocused &&
                    invalidCPF &&
                    messageValid &&
                    !isBlur && (
                      <Text color="red" opacity={0.8} mt={2} fontSize="12px">
                        {messageValid ? messageValid : ""}
                      </Text>
                    )}
                </FormControl>
              )}
            </Field>
          </GridItem>
          <GridItem colSpan={{ base: 1, sm: 3, lg: 4 }}>
            <Field name="nomeFamiliaAcolhedora">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.nomeFamiliaAcolhedora &&
                    form.touched.nomeFamiliaAcolhedora
                  }
                  id="nomeFamiliaAcolhedora"
                >
                  <FormLabel
                    color="#5F6377"
                    fontWeight="500"
                    fontSize="14px"
                    lineHeight="19.6px"
                    htmlFor="nomeFamiliaAcolhedora"
                  >
                    Nome*
                  </FormLabel>
                  <Input
                    {...field}
                    h="42px"
                    name="nomeFamiliaAcolhedora"
                    id="nomeFamiliaAcolhedora"
                    value={props.values.nomeFamiliaAcolhedora}
                    backgroundColor="#fff"
                    autoComplete="off"
                    border="1px solid #D7D8DE"
                    _placeholder={{
                      base: { fontSize: "14px" },
                      md: { fontSize: "16px" },
                    }}
                    isDisabled={disabledMPTJ}
                    placeholder="Informe o Nome Acolhedor"
                  />
                  <FormErrorMessage>
                    {form.errors.nomeFamiliaAcolhedora}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
          <GridItem colSpan={{ base: 1, sm: 3, lg: 2 }}>
            <CustomDatepickerWField
              inlineGrid={true}
              fieldName="dataNascimentoFamiliaAcolhedora"
              label="Data de Nascimento*"
              placeholder="DD/MM/AAAA"
              maxDate={new Date()}
              isDisabled={disabledMPTJ}
              defaultValue={props.values.dataNascimentoFamiliaAcolhedora}
            />
            {dataNascimentoFuturaFamilia &&
              props.values.dataNascimentoFamiliaAcolhedora && (
                <Text
                  mt="8px"
                  color="#E53E3E"
                  fontSize="sm"
                  lineHeight={"normal"}
                >
                  A data informada não pode ser uma data futura!
                </Text>
              )}
          </GridItem>
          <GridItem colSpan={{ base: 1, sm: 3, lg: 2 }}>
            <Flex alignItems="end" gap={2}>
              <CustomSelectWField
                fieldName="idGeneroFamiliaAcolhedora"
                label="Gênero*"
                placeholder="Selecione o Gênero"
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.id}
                defaultValue={props.values.idGeneroFamiliaAcolhedora}
                isLoading={generos.isLoading}
                options={generos.options}
                isDisabled={disabledMPTJ}
                onChange={(value) => {
                  setFieldValue("idGeneroFamiliaAcolhedora", value);
                }}
                onFocus={generos.options.length === 0 ? handleGetGeneros : null}
              />

              {props.values.idGeneroFamiliaAcolhedora && isMobile && (
                <PopoverGenero
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  handleClick={handleClick}
                  labelTextoGenero={
                    props.values?.idGeneroFamiliaAcolhedora?.label?.props
                      ?.children[1]?.props?.label
                  }
                />
              )}
            </Flex>
          </GridItem>
          {(props.values.genero
            ? props.values.genero.value === "Outros"
            : false) && (
            <GridItem colSpan={1}>
              <Field name="outros">
                {({ field, form }) => (
                  <FormControl
                    isInvalid={form.errors.outros && form.touched.outros}
                    id="outros"
                  >
                    <FormLabel
                      color="#5F6377"
                      fontWeight="500"
                      fontSize="14px"
                      lineHeight="19.6px"
                      htmlFor="outros"
                    >
                      Outros*
                    </FormLabel>
                    <Input
                      {...field}
                      h="42px"
                      name="outros"
                      id="outros"
                      backgroundColor="#fff"
                      autoComplete="off"
                      border="1px solid #D7D8DE"
                      _placeholder={{
                        base: { fontSize: "14px" },
                        md: { fontSize: "16px" },
                      }}
                      placeholder="Informe Outros"
                    />
                    <FormErrorMessage>{form.errors.outros}</FormErrorMessage>
                  </FormControl>
                )}
              </Field>
            </GridItem>
          )}
          <GridItem colSpan={{ base: 1, sm: 3, lg: 2 }}>
            <Field name="idBairroFamiliaAcolhedora">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.idBairroFamiliaAcolhedora &&
                    form.touched.idBairroFamiliaAcolhedora
                  }
                  id="idBairroFamiliaAcolhedora"
                >
                  <FormLabel
                    color="#5F6377"
                    fontWeight="500"
                    fontSize="14px"
                    lineHeight="19.6px"
                    htmlFor="idBairroFamiliaAcolhedora"
                  >
                    Bairro*
                  </FormLabel>
                  <CustomSelect
                    isInvalid={
                      form.errors.idBairroFamiliaAcolhedora &&
                      form.touched.idBairroFamiliaAcolhedora
                    }
                    searchable={true}
                    value={form.values.idBairroFamiliaAcolhedora || ""}
                    isClearable={true}
                    getOptionLabel={(option) => option.nome}
                    getOptionValue={(option) => option.id}
                    autoload={false}
                    isLoading={bairros.isLoading}
                    options={bairros.options}
                    placeholder="Selecione o Bairro"
                    isDisabled={disabledMPTJ}
                    onChange={(value) => {
                      form.setFieldValue(
                        "idBairroFamiliaAcolhedora",
                        value ? value : ""
                      );
                    }}
                  />
                  <FormErrorMessage>
                    {form.errors.idBairroFamiliaAcolhedora}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
          <GridItem colSpan={{ base: 1, sm: 3, lg: 2 }}>
            <CustomDatepickerWField
              inlineGrid={true}
              whiteSpace
              fieldName="dataValidadeTermoGuarda"
              label="Fim da Validade do Termo de Guarda"
              placeholder="DD/MM/AAAA"
            />
          </GridItem>
          {!movimentacaoEditar ? (
            <GridItem colSpan={{ base: 1, sm: 3, lg: 2 }}>
              <Flex>
                <CustomDropzone
                  whiteSpace={true}
                  formProps={props}
                  title={`Anexar Termo de Guarda${
                    props.values.dataValidadeTermoGuarda ? "*" : ""
                  }`}
                  fieldName="anexoTermoGuardaFamiliaAcolhedora"
                  height="42px"
                  titleText="Informe validade do termo de guarda"
                />
              </Flex>
            </GridItem>
          ) : (
            <GridItem colSpan={{ base: 2, sm: 2, lg: 1 }}>
              {anexoGuiaEditadoTermoGuarda ||
              !props.values.originalAnexoTermoGuarda ? (
                <Flex>
                  <CustomDropzone
                    whiteSpace={true}
                    formProps={props}
                    title={`Anexar Termo de Guarda ${
                      props.values.dataValidadeTermoGuarda ? "*" : ""
                    }`}
                    fieldName="anexoTermoGuardaFamiliaAcolhedora"
                    setAnexoNaoEditado={
                      props.values.originalAnexoTermoGuarda
                        ? () => {
                            setAnexoGuiaEditadoTermoGuarda(true);
                            props.setFieldValue(
                              "originalAnexoTermoGuarda",
                              null
                            );
                          }
                        : null
                    }
                    height="42px"
                    width={"216px"}
                  />
                </Flex>
              ) : (
                props.values.originalAnexoTermoGuarda && (
                  <FileInformation
                    label="Anexar Termo de Guarda"
                    name={props.values.originalAnexoTermoGuarda.arquivoNome}
                    path={props?.values?.originalAnexoTermoGuarda?.path
                      ?.toString()
                      .split("/")
                      .pop()}
                    setAnexoEditado={() => {
                      setAnexoGuiaEditadoTermoGuarda(true);
                    }}
                    isVisualizacao={false}
                    height="42px"
                    width={"216px"}
                  />
                )
              )}
            </GridItem>
          )}
        </Grid>
      </Form>
    </Group>
  );
};
